export default "__VITE_ASSET__CnVal0My__"